import { useMediaQuery } from "@shared/hooks/useMediaQuery";
import classNames from "classnames";

const FestivalCategoriesSkeleton = () => {
  const mobileMode = useMediaQuery("(max-width:576px)");
  return (
    <section className="mb-6 sm:mb-14 sm:-mt-fds-72 sm:px-8">
      <div className="xl:max-w-[1204px] mx-auto py-0 sm:px-6 sm:py-8 bg-white sm:rounded-lg relative shadow-md">
        <div className="px-5 flex gap-4 overflow-hidden">
          {[...Array(mobileMode ? 6 : 12)].map((_, index) => (
            <div
              key={index}
              className={classNames(
                "flex flex-col items-center pt-5 pb-3 gap-2 sm:gap-4 ",
                mobileMode ? "w-24 basis-24" : "w-28 basis-28"
              )}
            >
              <div
                className={classNames(
                  "animate-pulse rounded-10 bg-gray-200 ",
                  mobileMode ? "w-14 h-14" : "w-16 h-16"
                )}
              />
              <div
                className={classNames(
                  "animate-pulse rounded bg-gray-200",
                  mobileMode ? "w-14 h-3" : "w-20 h-4"
                )}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FestivalCategoriesSkeleton;
